interface IconProps {
  className?: string
}

export const PhoneIcon = ({ className }: IconProps) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    className={className}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m 16.6328,0.06429633 2.86e-4,-0.0042377 H 0.59882518 L 0.59765618,0.06270133 0.632812,16.059498 c 2.654e-5,0.01208 -2.1962861,6.02e-4 0.0128541,6.02e-4 H 16.632198 l 6.02e-4,0.0077 z M 10.6239,9.31339 c 0.4934,0.16 1.0222,0.24889 1.5689,0.24889 0.24,0 0.44,0.2 0.44,0.44002 v 1.5333 c 0,0.2445 -0.1244,0.5245 -0.44,0.5245 -4.12443,0 -7.55999,-3.43115 -7.55999,-7.56004 0,-0.33333 0.28889,-0.44 0.52889,-0.44 h 1.53778 c 0.24,0 0.44,0.2 0.44,0.44 0,0.54667 0.08444,1.07555 0.24889,1.56889 C 7.43726,6.2245 7.4017,6.39784 7.2817,6.52228 6.77106,6.95698 6.7535228,7.5870137 7.1523528,8.1261337 c 0.4226,0.57124 0.94402,1.08184 1.51219,1.49152 C 9.1962428,10.001034 9.7665,9.93268 10.175,9.42006 c 0.12,-0.12 0.2934,-0.16 0.4489,-0.10667 z'
      fill='currentColor'
    />
  </svg>
)
